define(['ko'], ko => {
    'use strict';

    /**
     * @typedef {Object} GlobalMediaControls
     * @property {Promise<AudioContext>} audioCtxPromise
     */
    const GlobalMediaControls = {
        paused: ko.observable(false),
        muted: ko.observable(true),
        caption: ko.observable(false),
        mainVideo: ko.observable(null),
        audioCtxPromise: null,

        addBackgroundTrack: async function (url) {
            const fetchPromise = fetch(url);
            const audioCtx = await this.audioCtxPromise;

            // eslint-disable-next-line func-style
            const updatePlayState = () => audioCtx[!this.muted() && !this.paused() ? 'resume' : 'suspend']();
            this.paused.subscribe(updatePlayState);
            this.muted.subscribe(updatePlayState);

            const audioBuffer = await audioCtx.decodeAudioData(await (await fetchPromise).arrayBuffer());
            const trackSrc = new AudioBufferSourceNode(audioCtx, {
                buffer: audioBuffer,
                loop: true
            });

            trackSrc.connect(audioCtx.destination);
            trackSrc.start();

            updatePlayState();
        },

        /**
         * @param {HTMLVideoElement} video video element
         * @returns {Promise<GainNode>} gain node for video's audio
         */
        addTrackFromVideo: async function (video) {
            const audioCtx = await this.audioCtxPromise;
            const videoAudio = audioCtx.createMediaElementSource(video);
            const gain = audioCtx.createGain();
            videoAudio.connect(gain);
            gain.connect(audioCtx.destination);
            return gain;
        }
    };
    GlobalMediaControls.audioCtxPromise = new Promise((resolve, reject) => {
        const sub = GlobalMediaControls.muted.subscribe(muted => {
            sub.dispose();
            resolve(new AudioContext());
        });
    });

    return GlobalMediaControls;
});
